import { Chip, styled } from '@mui/material';

export const ChipStyled = styled(Chip)(({ background, width = 100 }) => ({
    backgroundColor: background,
    color: 'var(--color-light-grey)',
    fontWeight: 'bold',
    borderRadius: 3,
    textTransform: 'capitalize',
    width,
}));
